<template>
    <project-step-container
            prev-to="rapid_experiments_with_customers_16"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="pb-3">
            <b-col cols="12">
                <img  width="95%" src="../Images/image-instructionsgo.svg" tabindex="0"
                     alt="A person doing a rapid experiment with a customer">
            </b-col>
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
               {{getMessage(17, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="content-box">
                <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide" :text="getMessage(17 , 'rapidexperiment-guide')" />
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {Steps} from "@/modules/D4D/Utils";

    export default {
        name: "RapidExperimentsWithCustomers17",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_EXPERIMENT_INSTRUCTIONS,
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.TYPES_EXPERIMENTS)
            }
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'rapid_experiments_with_customers_18', params: {index}})
            }
        },
    }
</script>

<style lang="stylus" scoped>

</style>
